<template>
  <div class="footer">
    <div class="col-md-12 footer">
      <div class="bg-dark text-center text-white">
        <div class="p-2 pb-0">
          <section class="mb-2">
            <a
              class="btn btn-outline-light btn-floating m-1"
              href="mailto:zarka08@gmail.com"
              role="button"
              ><i class="bi bi-google"></i
            ></a>
            <a
              class="btn btn-outline-light btn-floating m-1"
              href="tg://resolve?domain=zarka07"
              role="button"
              ><i class="bi bi-send"></i
            ></a>
            <a
              class="btn btn-outline-light btn-floating m-1"
              href="www.linkedin.com/in/serhii-tarasov/"
              role="button"
              ><i class="bi bi-linkedin"></i
            ></a>
            <a
              class="btn btn-outline-light btn-floating m-1"
              href="https://zarka07.github.io/"
              role="button"
              ><i class="bi bi-github"></i
            ></a>
          </section>
        </div>
        <div class="text-center p-3" style="background-color: #152733">
          © 2025 Copyright:
          <a class="text-white" href="mailto:zarka08@gmail.com">zarka08@gmail.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer-component",
};
</script>

<style scoped>
.footer {
  width: 100%;
  padding: 0;
}
</style>
